import React from "react";
import { TransportModeSelector } from "@/components/TariffSelector/TariffSelector";
import Map from "@/features/Map/Map";
import TelegramId from "@/components/TelegramId/TelegramId";
import { useChooseRegionStore } from "@/store/chooseRegion";
import AgglomerationSelector from "@/components/AgglomerationSelector/AgglomerationSelector";
import { AdminToolsProvider } from "@/store/AdminToolsProvider";
import WelcomeModal from "@/components/WelcomeModal/WelcomeModal";
import Notification from "@/components/Notification/Notification";
import { useSubscriptionStore } from "@/store/useSubscriptionStore";
import { SnapshotSelector } from "@/components/HistorySelector/SnapshotSelector";
import AddToHomeScreenPrompt from "@/components/AddToHomeScreenPrompt/AddToHomeScreenPrompt";

export const MainPage = () => {
  const { chooseRegion } = useChooseRegionStore();
  const { isSubscriptionActive } = useSubscriptionStore();

  if (chooseRegion && isSubscriptionActive) return <AgglomerationSelector />;

  return (
    <AdminToolsProvider>
      <TelegramId />
      <Notification />
      <WelcomeModal />
      <Map />
      <AddToHomeScreenPrompt />
      <SnapshotSelector />
      <TransportModeSelector />
    </AdminToolsProvider>
  );
};
